import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MenuItem } from 'primeng/api'
import { Subject } from 'rxjs'
import { AnalyticsService } from '@app/core/_services/analytics.service'
import { MenuModule } from 'primeng/menu'
import {
    ContentStackItemOptions,
    ContentStackService,
} from '@app/core/_services/content-stack.service'
import { ButtonModule } from 'primeng/button'
import { TagModule } from 'primeng/tag'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import {
    faLampDesk,
    faMicrophoneSlash,
    faPersonWalking,
    faShuffle,
} from '@fortawesome/pro-solid-svg-icons'
import {
    SESSION_ACTIVITY_TYPE_ANYTHING,
    SESSION_ACTIVITY_TYPE_DESK,
    SESSION_ACTIVITY_TYPE_MOVING,
    SessionActivityType,
} from '@app/core/_models'

@Component({
    selector: 'fm-actions-menu-availability-list',
    imports: [ButtonModule, MenuModule, TagModule, FontAwesomeModule],
    templateUrl: './actions-menu-availability-list.component.html',
    styleUrl: './actions-menu-availability-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsMenuAvailabilityListComponent {
    @Input() showSeeAvailability: boolean = true
    @Input() showViewProfile: boolean = true
    @Input() sessionExternalId: string | null = null
    @Input() targetUserProfileUrl: string | null = null
    @Input() source: string | null = null
    @Input() sharedAvailability: boolean = false
    @Input() saved: boolean = false
    @Input() activityType: SessionActivityType
    @Input() quietMode: boolean = true
    @Output() cancelSessionSelected = new EventEmitter<boolean>()

    items: MenuItem[] | undefined

    // Iocns
    public faMicrophoneSlash = faMicrophoneSlash
    public activityIcon

    private ngUnsubscribe: Subject<any> = new Subject<any>()
    public showSeeAvailabilityOption: boolean = false
    public menuItemClasses: string[]

    constructor(
        private analyticsService: AnalyticsService,
        private contentStackService: ContentStackService,
    ) {}

    ngOnInit() {
        this.updateMenu()
    }

    ngOnChanges() {
        this.updateMenu()
    }

    public updateMenu() {
        this.setActivityIcon()

        const menuItems: MenuItem[] = []

        this.showSeeAvailabilityOption = this.showSeeAvailability && this.saved

        if (this.showSeeAvailabilityOption) {
            menuItems.push({
                label: 'See availability',
                icon: 'pi pi-calendar',
                disabled: !this.sharedAvailability,
                toolTip: 'Add tooltip logic',
            })
        }

        if (this.showViewProfile) {
            menuItems.push({
                label: 'View profile',
                icon: 'pi pi-id-card',
                toolTip: 'Add tooltip logic',
                command: () => {
                    this.sendProfileToDynamicPanel()
                },
            })
        }

        if (this.sessionExternalId) {
            menuItems.push({
                label: 'Cancel session',
                icon: 'pi pi-times',
                toolTip: 'Add tooltip logic',
                command: () => {
                    this.triggerCancelRequest()
                },
            })
        }

        this.items = [...menuItems]
    }

    private setActivityIcon(): void {
        switch (this.activityType) {
            case SESSION_ACTIVITY_TYPE_ANYTHING:
                this.activityIcon = faShuffle
                break

            case SESSION_ACTIVITY_TYPE_DESK:
                this.activityIcon = faLampDesk
                break

            case SESSION_ACTIVITY_TYPE_MOVING:
                this.activityIcon = faPersonWalking
                break
        }
    }

    logSeeAvailability() {
        this.analyticsService.logClickedEvent('See availability', 'CSM - ' + this.source)
    }

    viewProfile() {
        this.analyticsService.logClickedEvent('View profile', 'CSM - ' + this.source)
    }

    private sendProfileToDynamicPanel(): void {
        const options: ContentStackItemOptions = {
            popIfCovered: true,
            preserveStack: true,
        }
        this.contentStackService.pushProfileToDynamicPanel(this.targetUserProfileUrl, options)
    }

    private triggerCancelRequest(): void {
        this.cancelSessionSelected.emit(true)
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }
}
